<template>
    <nut-popup v-model:visible="visible" style="background-color: transparent">
        <div class="dialog-content">
            <div class="content-box">
                <div class="title">中奖总览</div>
                <div class="list-box">
                    <div class="list-header">
                        <span>玩家名称</span>
                        <span>中奖道具</span>
                    </div>
                    <div class="list-content">
                        <nut-infinite-loading v-model="infinityValue" :has-more="hasMore" @load-more="loadMore">
                            <div class="list-item" v-for="item in list" :key="item.create_time">
                                <div class="urs">{{ item.variables.urs }}</div>
                                <div class="reward">{{ item.variables.reward_name }}</div>
                            </div>
                        </nut-infinite-loading>
                    </div>
                </div>
            </div>
            <div class="close-box" @click="closeModal">
                <TxButton src="gb" name="关闭中奖总览弹窗">
                </TxButton>
            </div>
        </div>
    </nut-popup>
</template>

<script lang="ts" setup>
import { ref, inject } from 'vue';
import eventEmitter from '@utils/event';
import useWeChatEnv from '@/plugins/vue/useWeChatOrMiniProgram';
import { query_danmu } from '@utils/api';

const { isWeChat, isMiniProgram } = useWeChatEnv();

const visible = ref(false)
const infinityValue = ref(false)
const hasMore = ref(true)
const loading = ref(false)
const list = ref([])

eventEmitter.on('showDanmuListModal', () => {
    if (list.value.length === 0) {
        queryDanmu()
    }
    visible.value = true
});

function closeModal() {
    visible.value = false
}

function queryDanmu(value = undefined) {
    if (loading.value) return
    loading.value = true
    query_danmu({
        activity_id: 'txwx',
        template_ids: [5],
        value,
        query_type: 3,
    }).then(res => {
        loading.value = false
        if (res.code !== 1) {
            return
        }
        list.value = [...list.value, ...res.data]
        // console.log(list.value);
        infinityValue.value = false
        hasMore.value = res.data.length > 0
    })
}

function loadMore() {
    queryDanmu(list.value.length > 0 ? list.value[list.value.length - 1].weight : undefined)
}


</script>

<style lang="scss" scoped>
.dialog-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: 24px;

    .content-box {
        @include bg('db_9');
        display: flex;
        flex-direction: column;
        align-items: center;
        box-sizing: border-box;
        padding-top: 60px;

        .title {
            font-size: 40px;
            color: #fff;
            padding-bottom: 50px;
        }

        .list-box {
            .list-header {
                display: flex;
                align-items: center;
                @include bg('wenzid');
                width: 626px !important;
                height: 41px !important;
                background-size: 626px 41px !important;
                color: #fff;

                span {
                    flex: 1;
                    text-align: center;
                }
            }

            .list-content {
                // width: 563px;
                height: 490px;
                // background-color: #acf;
                overflow: hidden;
                overflow-y: auto;

                .list-item {
                    display: flex;
                    align-items: center;
                    text-align: center;
                    font-size: 24px;
                    @include bg('db_12');
                    margin-bottom: 1px;

                    .urs {
                        flex: 1;
                    }

                    .reward {
                        flex: 1;
                    }
                }
            }
        }
    }

    .close-box {
        width: 100%;
        height: 100px;
        display: flex;
        justify-content: center;
        align-items: center; .close-icon {
            color: #fff;
        }
    }
}
</style>